import { createUser as k, generateUserKey as b, sendPerfMetrics as F, removeMessageFeedback as S, addMessageFeedback as T, getEvent as R, createEvent as w, deleteUser as I, updateUser as K, getUser as _, createFile as q, deleteMessage as N, getMessage as z, updateMessage as A, createMessage as J, listParticipants as j, getParticipant as D, removeParticipant as V, addParticipant as X, listConversationMessages as Y, listConversations as B, deleteConversation as G, getConversation as H, createConversation as O } from "./webchat-client3.js";
import { client as l } from "./webchat-client4.js";
import { EventSource as Q } from "./webchat-client5.js";
import { throwErrorInterceptor as C } from "./webchat-client6.js";
import { createEventEmitter as $ } from "./webchat-client7.js";
const r = (a) => a.data, M = 10, P = 3e3, W = "60000", v = {
  throwOnError: !0
}, ne = async ({
  clientId: a,
  apiUrl: c,
  adminSecret: d,
  customHeaders: o,
  ...h
}) => {
  const t = `${c || l.getConfig().baseUrl}/${a}`;
  l.interceptors.response._fns.length === 0 && l.interceptors.response.use(C);
  const i = {
    ...v,
    baseUrl: t
  }, s = {
    ...d ? { "x-admin-secret": d } : {},
    ...o
  };
  return k({
    ...i,
    headers: Object.keys(s).length > 0 ? s : void 0,
    body: h
  }).then(r);
}, ae = ({
  conversationId: a,
  userToken: c,
  clientId: d,
  apiUrl: o,
  adminSecret: h
}) => {
  let t = 0, i = null;
  const s = $(), m = () => {
    i && i.close();
    const n = `${`${o || l.getConfig().baseUrl}/${d}`}/initialize${a ? `?conversationId=${a}` : ""}`, g = {
      ...h ? { "x-admin-secret": h } : {},
      ...c ? { "x-user-key": c } : {}
    };
    i = L(n, g), i.addEventListener("open", () => s.emit("open")), i.addEventListener("error", (p) => {
      t < M ? (t++, setTimeout(() => m(), P)) : s.emit("error", p);
    }), i.addEventListener("message", (p) => {
      const u = x(p.data);
      s.emit(u.type, u.data);
    });
  };
  return m(), s.on;
}, oe = async ({
  adminSecret: a,
  expiresAt: c,
  userId: d,
  apiUrl: o,
  clientId: h
}) => {
  const t = { "x-admin-secret": a }, i = `${o || l.getConfig().baseUrl}/${h}`, s = {
    ...v,
    baseUrl: i
  };
  return b({ ...s, headers: t, body: { id: d, expiresAt: c } }).then(r);
}, ie = async (a, c, d, o) => {
  const h = `${d || l.getConfig().baseUrl}/${a}`, t = {
    ...v,
    baseUrl: h
  };
  return F({ ...t, body: c, headers: o }).then(r);
}, ce = ({
  userKey: a,
  clientId: c,
  apiUrl: d,
  customHeaders: o,
  advancedOptions: h
}) => {
  const t = {
    "x-user-key": a,
    ...o
  }, i = `${d || l.getConfig().baseUrl}/${c}`, s = {
    ...v,
    baseUrl: i
  };
  return l.interceptors.response._fns.length === 0 && l.interceptors.response.use(C), {
    createConversation: () => O({ ...s, headers: t, body: {} }).then(r),
    getConversation: ({ conversationId: e }) => H({ ...s, headers: t, path: { id: e } }).then(r),
    deleteConversation: ({ conversationId: e }) => G({ ...s, headers: t, path: { id: e } }).then(r),
    listConversations: ({ nextToken: e }) => B({ ...s, headers: t, query: { nextToken: e } }).then(r),
    listConversationMessages: ({ conversationId: e, nextToken: n }) => Y({
      ...s,
      headers: t,
      path: { id: e },
      query: { nextToken: n }
    }).then(r),
    addParticipant: ({ conversationId: e, userId: n }) => X({ ...s, headers: t, path: { id: e }, body: { userId: n } }).then(r),
    removeParticipant: ({ conversationId: e, userId: n }) => V({ ...s, headers: t, path: { id: e, userId: n } }).then(r),
    getParticipant: ({ conversationId: e, userId: n }) => D({ ...s, headers: t, path: { id: e, userId: n } }).then(r),
    listParticipants: ({ conversationId: e, nextToken: n }) => j({ ...s, headers: t, path: { id: e }, query: { nextToken: n } }).then(r),
    createMessage: (e) => J({ ...s, headers: t, body: e }).then(r),
    updateMessage: ({ messageId: e, ...n }) => A({ ...s, headers: t, path: { id: e }, body: n }).then(r),
    getMessage: ({ messageId: e }) => z({ ...s, headers: t, path: { id: e } }).then(r),
    deleteMessage: ({ messageId: e }) => N({ ...s, headers: t, path: { id: e } }).then(r),
    createFile: (e) => q({ ...s, headers: t, body: e }).then(r),
    getUser: () => _({ ...s, headers: t }).then(r),
    updateUser: (e) => K({ ...s, headers: t, body: e }).then(r),
    deleteUser: () => I({ ...s, headers: t }).then(r),
    createEvent: (e) => w({ ...s, headers: t, body: e }).then(r),
    getEvent: ({ eventId: e }) => R({ ...s, headers: t, path: { id: e } }).then(r),
    addMessageFeedback: ({ messageId: e, ...n }) => T({ ...s, headers: t, path: { id: e }, body: n }).then(r),
    removeMessageFeedback: ({ messageId: e }) => S({ ...s, headers: t, path: { id: e } }).then(r),
    generateUserKey: ({ adminSecret: e, ...n }) => b({ ...s, headers: { "x-admin-secret": e }, body: n }).then(r),
    listenConversation: ({ conversationId: e }) => {
      let n = 0, g = null;
      const p = $(), u = () => {
        g && g.close();
        const U = `${i}/conversations/${e}/listen`, E = h == null ? void 0 : h.eventSource;
        g = E ? E({ url: U, headers: t }) : L(U, t), g.addEventListener("open", () => p.emit("open")), g.addEventListener("error", (f) => {
          n < M ? (n++, setTimeout(() => u(), P)) : p.emit("error", f);
        }), g.addEventListener("message", (f) => {
          const y = x(f.data);
          p.emit(y.type, y.data);
        });
      };
      return u(), p.on;
    }
  };
}, x = (a) => {
  try {
    return JSON.parse(a);
  } catch {
    return a;
  }
}, L = (a, c) => new Q(a, {
  fetch: (d, o) => fetch(d, {
    ...o,
    headers: {
      ...o == null ? void 0 : o.headers,
      ...c,
      timeout: W
    }
  })
});
export {
  ce as createClient,
  ne as createUser,
  oe as generateUserKey,
  ae as initialize,
  ie as sendPerfMetrics
};
